import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type FormErrorProps = WithClassName<{
	text: string | undefined
}>

export const FormError = ({ className, text }: FormErrorProps) => {
	if (!text) return null

	return <span className={cn('inline-block text-2xs font-bold text-red', className)}>{text}</span>
}
